import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SvgCheckmark from '../icons/SvgCheckmark';
const Achievement = ({ kind, done }) => {
    return (_jsxs(_Fragment, { children: [kind, done &&
                _jsx("div", { className: "inline-block relative top-2 left-05 rounded-full px-2", children: _jsx(SvgCheckmark, { className: "h-4 w-4 fill-current" }) })] }));
};
export default Achievement;
